module.exports = "/_next/static/images/31a9262ddf15269a1f7699bc61d59645-debit-pre-ric.svg.webp";